import React from 'react';
import { CtaButton } from './ui/CtaButton';
const STUDIO = 'https://cdn.magicpatterns.com/patterns/generated-images/b3a8acf5-cf08-4526-827a-0cb13bdd3241.jpg';
export function FinalCtaSection() {
  return <section className="relative w-full overflow-hidden bg-forestDeep" aria-labelledby="final-heading" data-id="element-36" data-mp="3qt9kcy8plkqx">
      <img src={STUDIO} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-[0.12]" loading="lazy" data-id="element-37" data-mp="3vs43k1al9bbk" />
      <div className="relative mx-auto w-full max-w-2xl px-5 py-12 text-center sm:px-8 sm:py-16" data-id="element-38" data-mp="33505yhdtrz9t">
        <h2 id="final-heading" className="font-serif text-[1.6rem] font-semibold uppercase leading-[1.08] text-ivory sm:text-4xl" data-id="element-39" data-mp="3820auoyxuvzc">
          Your next yoga class doesn’t
          <span className="block text-goldSoft" data-id="element-40" data-mp="2fdbbaudj6ypp">have to start with a blank page.</span>
        </h2>

        <p className="mx-auto mt-4 max-w-xs text-[0.9rem] leading-relaxed text-ivory/75 sm:text-base" data-id="element-41" data-mp="2kcfjpismssez">
          Open the library. Choose your class. Review the structure. Teach.
        </p>

        <p className="mt-4 font-serif text-base uppercase tracking-label text-ivory/85 sm:text-xl" data-id="element-42" data-mp="28dyjbg0q3xc9">
          Open <span className="text-goldSoft" data-id="element-43" data-mp="23l5hazwn333v">•</span> Choose{' '}
          <span className="text-goldSoft" data-id="element-44" data-mp="1yndn1z8iv4wi">•</span> Teach
        </p>

        <p className="mt-5 font-serif text-[0.68rem] uppercase tracking-label text-ivory/60" data-id="element-45" data-mp="1yl187uy29ano">
          Yoga Teacher System™
        </p>
        <p className="mt-1 font-serif text-4xl font-semibold leading-none text-ivory sm:text-5xl" data-id="element-46" data-mp="1pmpbrcaijinb">
          $19 <span className="text-base font-normal text-ivory/60" data-id="element-47" data-mp="1kmt2oymyl10w">USD</span>
        </p>

        <div className="mt-6" data-id="element-48" data-mp="1fohu0r8egwk9">
          <CtaButton tone="light" label="Get instant access" microcopy="One-Time Purchase • Instant Access • 7-Day Guarantee" data-id="element-49" data-mp="1fpb5u6m7uc99" />
        </div>
      </div>
    </section>;
}